import { Zap } from 'lucide-react';
import { NetworkGauge } from '@evi/ui';
import type { OperatorDashboardData } from '@evi/shared';
import ChartPlaceholder from './ChartPlaceholder';

export default function ChartNetwork({ summary }: { summary: OperatorDashboardData | undefined }) {
  return summary ? (
    <NetworkGauge
      online={summary.network.online}
      total={summary.network.total}
      faulted={summary.network.faulted}
    />
  ) : (
    <ChartPlaceholder title="Network status" icon={Zap} desc="Loading…" />
  );
}
